export * from "./SignatureV4";
export { getCanonicalHeaders } from "./getCanonicalHeaders";
export { getCanonicalQuery } from "./getCanonicalQuery";
export { getPayloadHash } from "./getPayloadHash";
export { moveHeadersToQuery } from "./moveHeadersToQuery";
export { prepareRequest } from "./prepareRequest";
export { normalizeCredentialsProvider, normalizeRegionProvider } from "./normalizeProvider";
export * from "./credentialDerivation";
